/* This file is generated by a script, to edit it go to 'scripts/generateTimezones.ts' */
export const timezonesCities = {
  'Pacific/Midway': ['Midway'],
  'Pacific/Pago_Pago': ['Pago Pago'],
  'Pacific/Niue': ['Alofi'],
  'Pacific/Rarotonga': ['Avarua'],
  'America/Adak': ['Adak'],
  'Pacific/Honolulu': [
    'Honolulu',
    'East Honolulu',
    'Pearl City',
    'Makakilo / Kapolei / Honokai Hale',
  ],
  'Pacific/Tahiti': ['Faaa', 'Papeete', 'Punaauia'],
  'Pacific/Marquesas': ['Marquesas'],
  'America/Anchorage': ['Anchorage', 'Fairbanks', 'Juneau', 'Eagle River'],
  'Pacific/Gambier': ['Gambier'],
  'America/Los_Angeles': ['Los Angeles', 'San Diego', 'San Jose', 'San Francisco'],
  'America/Tijuana': ['Tijuana', 'Mexicali', 'Ensenada', 'Rosarito'],
  'America/Vancouver': ['Vancouver', 'Surrey', 'Victoria', 'Burnaby'],
  'Pacific/Pitcairn': ['Adamstown'],
  'America/Hermosillo': ['Hermosillo', 'Culiacán', 'Mazatlán', 'Tepic'],
  'America/Edmonton': ['Calgary', 'Edmonton', 'Lethbridge', 'Red Deer'],
  'America/Ciudad_Juarez': ['Ciudad Juárez'],
  'America/Denver': ['Denver', 'El Paso', 'Albuquerque', 'Colorado Springs'],
  'America/Phoenix': ['Phoenix', 'Tucson', 'Mesa', 'Chandler'],
  'America/Whitehorse': ['Whitehorse', 'Fort St. John', 'Creston', 'Dawson'],
  'America/Belize': ['Belize City', 'San Pedro', 'Orange Walk', 'Belmopan'],
  'America/Chicago': ['Chicago', 'Houston', 'San Antonio', 'Dallas'],
  'America/Guatemala': ['Guatemala City', 'Villa Nueva', 'Mixco', 'Cobán'],
  'America/Managua': ['Managua', 'León', 'Masaya', 'Chinandega'],
  'America/Mexico_City': ['Mexico City', 'Iztapalapa', 'Puebla', 'Ecatepec de Morelos'],
  'America/Matamoros': ['Reynosa', 'Heroica Matamoros', 'Nuevo Laredo', 'Piedras Negras'],
  'America/Costa_Rica': ['San José', 'Limón', 'San Francisco', 'Alajuela'],
  'America/El_Salvador': ['San Salvador', 'Soyapango', 'San Miguel', 'Santa Ana'],
  'America/Regina': ['Saskatoon', 'Regina', 'Prince Albert', 'Moose Jaw'],
  'America/Tegucigalpa': ['Tegucigalpa', 'San Pedro Sula', 'La Ceiba', 'Choloma'],
  'America/Winnipeg': ['Winnipeg', 'Brandon', 'Steinbach', 'Kenora'],
  'Pacific/Easter': ['Easter'],
  'Pacific/Galapagos': ['Galapagos'],
  'America/Rio_Branco': ['Rio Branco', 'Cruzeiro do Sul', 'Tarauacá', 'Sena Madureira'],
  'America/Bogota': ['Bogotá', 'Cali', 'Medellín', 'Barranquilla'],
  'America/Havana': ['Havana', 'Santiago de Cuba', 'Camagüey', 'Holguín'],
  'America/Atikokan': ['Atikokan'],
  'America/Cancun': ['Cancún', 'Chetumal', 'Playa del Carmen', 'Cozumel'],
  'America/Cayman': ['George Town', 'West Bay'],
  'America/Jamaica': ['Kingston', 'New Kingston', 'Spanish Town', 'Portmore'],
  'America/Nassau': ['Nassau', 'Lucaya', 'Freeport', 'Killarney'],
  'America/New_York': ['New York City', 'Brooklyn', 'Queens', 'Philadelphia'],
  'America/Panama': ['Panamá', 'San Miguelito', 'Juan Díaz', 'David'],
  'America/Port-au-Prince': ['Port-au-Prince', 'Carrefour', 'Delmas', 'Port-de-Paix'],
  'America/Grand_Turk': ['Providenciales', 'Cockburn Town'],
  'America/Toronto': ['Toronto', 'Montréal', 'Ottawa', 'Mississauga'],
  'America/Guayaquil': ['Quito', 'Guayaquil', 'Cuenca', 'Santo Domingo de los Colorados'],
  'America/Lima': ['Lima', 'Callao', 'Arequipa', 'Trujillo'],
  'America/Manaus': ['Manaus', 'Campo Grande', 'Cuiabá', 'Porto Velho'],
  'America/St_Kitts': ['Basseterre'],
  'America/Blanc-Sablon': ['Blanc-Sablon'],
  'America/Montserrat': ['Brades', 'Plymouth'],
  'America/Barbados': ['Bridgetown'],
  'America/Port_of_Spain': ['Chaguanas', 'Mon Repos', 'San Fernando', 'Port of Spain'],
  'America/Martinique': ['Fort-de-France', 'Le Lamentin', 'Le Robert', 'Sainte-Marie'],
  'America/St_Lucia': ['Gros Islet', 'Castries'],
  'America/St_Barthelemy': ['Gustavia'],
  'America/Halifax': ['Halifax', 'Sydney', 'Dartmouth', 'Moncton'],
  'Atlantic/Bermuda': ['Hamilton'],
  'America/St_Vincent': ['Kingstown', 'Calliaqua'],
  'America/Kralendijk': ['Kralendijk'],
  'America/Guadeloupe': ['Les Abymes', 'Baie-Mahault', 'Le Gosier', 'Petit-Bourg'],
  'America/Marigot': ['Marigot'],
  'America/Aruba': ['Oranjestad', 'Noord', 'Tanki Leendert', 'San Nicolas'],
  'America/Lower_Princes': ['Philipsburg'],
  'America/Tortola': ['Road Town'],
  'America/Dominica': ['Roseau'],
  'America/St_Thomas': ['Saint Croix', 'Charlotte Amalie'],
  'America/Grenada': ["Saint George's"],
  'America/Antigua': ['Saint John’s'],
  'America/Puerto_Rico': ['San Juan', 'Bayamón', 'Carolina', 'Ponce'],
  'America/Santo_Domingo': [
    'Santo Domingo',
    'Santiago de los Caballeros',
    'Santo Domingo Oeste',
    'Santo Domingo Este',
  ],
  'America/Anguilla': ['The Valley'],
  'America/Thule': ['Thule'],
  'America/Curacao': ['Willemstad', 'Bandariba'],
  'America/La_Paz': ['La Paz', 'Santa Cruz de la Sierra', 'Cochabamba', 'Sucre'],
  'America/Santiago': ['Santiago', 'Puente Alto', 'Antofagasta', 'Viña del Mar'],
  'America/Guyana': ['Georgetown', 'Linden', 'New Amsterdam'],
  'America/Caracas': ['Caracas', 'Maracaibo', 'Valencia', 'Barquisimeto'],
  'America/St_Johns': ["St. John's", 'Mount Pearl', 'Paradise', 'Corner Brook'],
  'America/Argentina/Buenos_Aires': ['Buenos Aires', 'Córdoba', 'Rosario', 'Mar del Plata'],
  'America/Sao_Paulo': ['São Paulo', 'Rio de Janeiro', 'Belo Horizonte', 'Salvador'],
  'Antarctica/Palmer': ['Palmer', 'Rothera'],
  'America/Punta_Arenas': ['Punta Arenas', 'Coyhaique', 'Puerto Natales', 'Puerto Aysén'],
  'Atlantic/Stanley': ['Stanley'],
  'America/Cayenne': ['Cayenne', 'Matoury', 'Saint-Laurent-du-Maroni', 'Kourou'],
  'America/Asuncion': ['Asunción', 'Ciudad del Este', 'San Lorenzo', 'Capiatá'],
  'America/Miquelon': ['Saint-Pierre'],
  'America/Paramaribo': ['Paramaribo', 'Lelydorp'],
  'America/Montevideo': ['Montevideo', 'Salto', 'Paysandú', 'Las Piedras'],
  'America/Noronha': ['Noronha'],
  'America/Nuuk': ['Nuuk', 'Scoresbysund'],
  'Atlantic/South_Georgia': ['Grytviken'],
  'Atlantic/Azores': ['Ponta Delgada'],
  'Atlantic/Cape_Verde': ['Praia', 'Mindelo', 'Espargos', 'Assomada'],
  'Africa/Abidjan': ['Abidjan', 'Abobo', 'Bouaké', 'Korhogo'],
  'Africa/Bamako': ['Bamako', 'Sikasso', 'Koutiala', 'Ségou'],
  'Africa/Bissau': ['Bissau', 'Gabú', 'Bafatá'],
  'Africa/Conakry': ['Conakry', 'Camayenne', 'Nzérékoré', 'Kankan'],
  'Africa/Dakar': ['Dakar', 'Touba', 'Pikine', 'Guédiawaye'],
  'America/Danmarkshavn': ['Danmarkshavn'],
  'Europe/Isle_of_Man': ['Douglas'],
  'Europe/Dublin': ['Dublin', 'South Dublin', 'Cork', 'Limerick'],
  'Africa/Freetown': ['Freetown', 'Bo', 'Kenema', 'Koidu'],
  'Atlantic/St_Helena': ['Jamestown'],
  'Africa/Accra': ['Kumasi', 'Accra', 'Tamale', 'Takoradi'],
  'Africa/Lome': ['Lomé', 'Sokodé', 'Kara', 'Atakpamé'],
  'Europe/London': ['London', 'Birmingham', 'Glasgow', 'Manchester'],
  'Africa/Monrovia': ['Monrovia', 'Gbarnga', 'Buchanan', 'Ganta'],
  'Africa/Nouakchott': ['Nouakchott', 'Nouadhibou', 'Kiffa', 'Dar Naim'],
  'Africa/Ouagadougou': ['Ouagadougou', 'Bobo-Dioulasso', 'Koudougou', 'Saaba'],
  'Atlantic/Reykjavik': ['Reykjavík', 'Kópavogur', 'Hafnarfjörður', 'Reykjanesbær'],
  'Europe/Jersey': ['Saint Helier'],
  'Europe/Guernsey': ['Saint Peter Port'],
  'Africa/Banjul': ['Serekunda', 'Brikama', 'Bununka Kunda', 'Sukuta'],
  'Africa/Sao_Tome': ['São Tomé'],
  'Antarctica/Troll': ['Troll'],
  'Africa/Casablanca': ['Casablanca', 'Rabat', 'Fes', 'Tangier'],
  'Africa/El_Aaiun': ['Laayoune', 'Dakhla', 'Boujdour'],
  'Atlantic/Canary': ['Las Palmas de Gran Canaria', 'Santa Cruz de Tenerife', 'La Laguna', 'Telde'],
  'Europe/Lisbon': ['Lisbon', 'Porto', 'Amadora', 'Braga'],
  'Atlantic/Faroe': ['Tórshavn'],
  'Africa/Windhoek': ['Windhoek', 'Rundu', 'Walvis Bay', 'Swakopmund'],
  'Africa/Algiers': ['Algiers', 'Oran', 'Constantine', 'Annaba'],
  'Europe/Amsterdam': ['Amsterdam', 'Rotterdam', 'The Hague', 'Utrecht'],
  'Europe/Andorra': ['Andorra la Vella', 'les Escaldes'],
  'Europe/Belgrade': ['Belgrade', 'Niš', 'Novi Sad', 'Zemun'],
  'Europe/Berlin': ['Berlin', 'Hamburg', 'Munich', 'Köln'],
  'Europe/Bratislava': ['Bratislava', 'Košice', 'Petržalka', 'Nitra'],
  'Europe/Brussels': ['Brussels', 'Antwerpen', 'Gent', 'Charleroi'],
  'Europe/Budapest': ['Budapest', 'Debrecen', 'Szeged', 'Miskolc'],
  'Europe/Copenhagen': ['Copenhagen', 'Århus', 'Odense', 'Aalborg'],
  'Europe/Gibraltar': ['Gibraltar'],
  'Europe/Ljubljana': ['Ljubljana', 'Maribor', 'Kranj', 'Celje'],
  'Arctic/Longyearbyen': ['Longyearbyen'],
  'Europe/Luxembourg': ['Luxembourg', 'Esch-sur-Alzette', 'Dudelange'],
  'Europe/Madrid': ['Madrid', 'Barcelona', 'Valencia', 'Sevilla'],
  'Europe/Monaco': ['Monaco', 'Monte-Carlo'],
  'Europe/Oslo': ['Oslo', 'Bergen', 'Trondheim', 'Stavanger'],
  'Europe/Paris': ['Paris', 'Marseille', 'Lyon', 'Toulouse'],
  'Europe/Podgorica': ['Podgorica', 'Nikšić', 'Herceg Novi', 'Pljevlja'],
  'Europe/Prague': ['Prague', 'Brno', 'Ostrava', 'Pilsen'],
  'Europe/Rome': ['Rome', 'Milan', 'Naples', 'Turin'],
  'Europe/San_Marino': ['San Marino'],
  'Europe/Malta': ['San Pawl il-Baħar', 'Birkirkara', 'Mosta', 'Sliema'],
  'Europe/Sarajevo': ['Sarajevo', 'Banja Luka', 'Zenica', 'Tuzla'],
  'Europe/Skopje': ['Skopje', 'Kumanovo', 'Prilep', 'Bitola'],
  'Europe/Stockholm': ['Stockholm', 'Göteborg', 'Malmö', 'Uppsala'],
  'Europe/Tirane': ['Tirana', 'Durrës', 'Vlorë', 'Elbasan'],
  'Africa/Tunis': ['Tunis', 'Sfax', 'Sousse', 'Kairouan'],
  'Europe/Vaduz': ['Vaduz'],
  'Europe/Vatican': ['Vatican City'],
  'Europe/Vienna': ['Vienna', 'Graz', 'Linz', 'Favoriten'],
  'Europe/Warsaw': ['Warsaw', 'Łódź', 'Kraków', 'Wrocław'],
  'Europe/Zagreb': ['Zagreb', 'Split', 'Rijeka', 'Osijek'],
  'Europe/Zurich': ['Zürich', 'Genève', 'Basel', 'Lausanne'],
  'Africa/Bangui': ['Bangui', 'Bimbo', 'Bégoua', 'Carnot'],
  'Africa/Malabo': ['Bata', 'Malabo', 'Ebebiyin'],
  'Africa/Brazzaville': ['Brazzaville', 'Pointe-Noire', 'Dolisie', 'Nkayi'],
  'Africa/Porto-Novo': ['Cotonou', 'Abomey-Calavi', 'Porto-Novo', 'Parakou'],
  'Africa/Douala': ['Douala', 'Yaoundé', 'Bamenda', 'Bafoussam'],
  'Africa/Kinshasa': ['Kinshasa', 'Kikwit', 'Masina', 'Mbandaka'],
  'Africa/Lagos': ['Lagos', 'Kano', 'Ibadan', 'Abuja'],
  'Africa/Libreville': ['Libreville', 'Port-Gentil', 'Franceville', 'Owendo'],
  'Africa/Luanda': ['Luanda', 'Lubango', 'Huambo', 'Benguela'],
  'Africa/Ndjamena': ["N'Djamena", 'Moundou', 'Abéché', 'Sarh'],
  'Africa/Niamey': ['Niamey', 'Maradi', 'Zinder', 'Tahoua'],
  'Africa/Bujumbura': ['Bujumbura', 'Gitega', 'Ngozi', 'Rumonge'],
  'Africa/Gaborone': ['Gaborone', 'Francistown', 'Mogoditshane', 'Maun'],
  'Africa/Harare': ['Harare', 'Bulawayo', 'Chitungwiza', 'Mutare'],
  'Africa/Juba': ['Juba', 'Winejok', 'Yei', 'Malakal'],
  'Africa/Khartoum': ['Khartoum', 'Omdurman', 'Khartoum North', 'Nyala'],
  'Africa/Kigali': ['Kigali', 'Gisenyi', 'Nyagatare', 'Butare'],
  'Africa/Blantyre': ['Lilongwe', 'Blantyre', 'Mzuzu', 'Zomba'],
  'Africa/Lubumbashi': ['Lubumbashi', 'Mbuji-Mayi', 'Kananga', 'Kisangani'],
  'Africa/Lusaka': ['Lusaka', 'Kitwe', 'Ndola', 'Chipata'],
  'Africa/Maputo': ['Maputo', 'Matola', 'Nampula', 'Beira'],
  'Europe/Athens': ['Athens', 'Thessaloníki', 'Pátra', 'Piraeus'],
  'Asia/Beirut': ['Beirut', 'Ra’s Bayrūt', 'Tripoli', 'Sidon'],
  'Europe/Bucharest': ['Bucharest', 'Sector 3', 'Iaşi', 'Sector 6'],
  'Africa/Cairo': ['Cairo', 'Alexandria', 'Giza', 'Shubrā al Khaymah'],
  'Europe/Chisinau': ['Chisinau', 'Tiraspol', 'Bălţi', 'Bender'],
  'Asia/Hebron': ['East Jerusalem', 'Gaza', 'Khān Yūnis', 'Jabālyā'],
  'Europe/Helsinki': ['Helsinki', 'Espoo', 'Tampere', 'Oulu'],
  'Europe/Kaliningrad': ['Kaliningrad', 'Chernyakhovsk', 'Sovetsk', 'Baltiysk'],
  'Europe/Kyiv': ['Kyiv', 'Kharkiv', 'Odesa', 'Dnipro'],
  'Europe/Mariehamn': ['Mariehamn'],
  'Asia/Nicosia': ['Nicosia', 'Limassol', 'Larnaca', 'Stróvolos'],
  'Europe/Riga': ['Riga', 'Daugavpils', 'Liepāja', 'Jelgava'],
  'Europe/Sofia': ['Sofia', 'Plovdiv', 'Varna', 'Burgas'],
  'Europe/Tallinn': ['Tallinn', 'Tartu', 'Narva', 'Pärnu'],
  'Africa/Tripoli': ['Tripoli', 'Benghazi', 'Misratah', 'Zliten'],
  'Europe/Vilnius': ['Vilnius', 'Kaunas', 'Klaipėda', 'Šiauliai'],
  'Asia/Jerusalem': ['Jerusalem', 'Tel Aviv', 'West Jerusalem', 'Haifa'],
  'Africa/Johannesburg': ['Johannesburg', 'Cape Town', 'Durban', 'Pretoria'],
  'Africa/Mbabane': ['Manzini', 'Mbabane', 'Lobamba'],
  'Africa/Maseru': ['Maseru', 'Maputsoe', "Mohale's Hoek", 'Mafeteng'],
  'Asia/Kuwait': ['Al Aḩmadī', 'Ḩawallī', 'As Sālimīyah', 'Şabāḩ as Sālim'],
  'Asia/Bahrain': ['Ar Rifā‘', 'Manama', 'Al Muharraq', 'Dār Kulayb'],
  'Asia/Baghdad': ['Baghdad', 'Al Mawşil al Jadīdah', 'Al Başrah al Qadīmah', 'Mosul'],
  'Asia/Qatar': ['Doha', 'Ar Rayyān', 'Al Maţār al ‘Atīq', 'Al Manşūrah'],
  'Asia/Riyadh': ['Jeddah', 'Riyadh', 'Makkah', 'Madinah'],
  'Asia/Aden': ['Sanaa', 'Aden', 'Taiz', 'Ibb'],
  'Asia/Amman': ['Amman', 'Zarqa', 'Irbid', 'Russeifa'],
  'Asia/Damascus': ['Aleppo', 'Damascus', 'Homs', 'Latakia'],
  'Africa/Addis_Ababa': ['Addis Ababa', 'Jijiga', 'Gonder', "Mek'ele"],
  'Indian/Antananarivo': ['Antananarivo', 'Toamasina', 'Antsirabe', 'Mahajanga'],
  'Africa/Asmara': ['Asmara', 'Keren', 'Himora', 'Massawa'],
  'Africa/Dar_es_Salaam': ['Dar es Salaam', 'Mwanza', 'Dodoma', 'Zanzibar'],
  'Africa/Djibouti': ['Djibouti', 'Ali Sabih', 'Dikhil', 'Tadjoura'],
  'Africa/Kampala': ['Kampala', 'Nansana', 'Kira', 'Bunamwaya'],
  'Indian/Mayotte': ['Mamoudzou', 'Koungou', 'Labattoir', 'Kaouéni'],
  'Africa/Mogadishu': ['Mogadishu', 'Borama', 'Hargeysa', 'Berbera'],
  'Indian/Comoro': ['Moroni', 'Moutsamoudou', 'Fomboni'],
  'Africa/Nairobi': ['Nairobi', 'Kakamega', 'Mombasa', 'Nakuru'],
  'Europe/Minsk': ['Minsk', "Homyel'", 'Hrodna', 'Vitebsk'],
  'Europe/Moscow': ['Moscow', 'Saint Petersburg', 'Nizhniy Novgorod', 'Kazan'],
  'Europe/Simferopol': ['Sevastopol', 'Simferopol', 'Kerch', 'Yevpatoriya'],
  'Antarctica/Syowa': ['Syowa'],
  'Europe/Istanbul': ['Istanbul', 'Ankara', 'Bursa', 'İzmir'],
  'Asia/Tehran': ['Tehran', 'Mashhad', 'Isfahan', 'Karaj'],
  'Asia/Yerevan': ['Yerevan', 'Malatia-Sebastia', 'Shengavit', 'Nor Nork'],
  'Asia/Baku': ['Baku', 'Sumqayıt', 'Ganja', 'Lankaran'],
  'Asia/Tbilisi': ['Tbilisi', 'Batumi', 'Kutaisi', 'Rustavi'],
  'Asia/Dubai': ['Dubai', 'Abu Dhabi', 'Sharjah', 'Al Ain City'],
  'Asia/Muscat': ['Muscat', 'Seeb', 'Bawshar', '‘Ibrī'],
  'Indian/Mauritius': ['Port Louis', 'Vacoas', 'Beau Bassin-Rose Hill', 'Curepipe'],
  'Indian/Reunion': ['Saint-Denis', 'Saint-Paul', 'Saint-Pierre', 'Le Tampon'],
  'Europe/Samara': ['Samara', 'Saratov', 'Tolyatti', 'Izhevsk'],
  'Indian/Mahe': ['Victoria'],
  'Asia/Kabul': ['Kabul', 'Herāt', 'Mazār-e Sharīf', 'Kandahār'],
  'Indian/Kerguelen': ['Port-aux-Français'],
  'Asia/Almaty': ['Almaty', 'Shymkent', 'Aktobe', 'Karagandy'],
  'Indian/Maldives': ['Male'],
  'Antarctica/Mawson': ['Mawson', 'Vostok'],
  'Asia/Karachi': ['Lahore', 'Karachi', 'Peshawar', 'Faisalabad'],
  'Asia/Dushanbe': ['Dushanbe', 'Isfara', 'Istaravshan', 'Kŭlob'],
  'Asia/Ashgabat': ['Ashgabat', 'Türkmenabat', 'Daşoguz', 'Mary'],
  'Asia/Tashkent': ['Tashkent', 'Andijon', 'Namangan', 'Samarkand'],
  'Asia/Yekaterinburg': ['Yekaterinburg', 'Chelyabinsk', 'Ufa', 'Perm'],
  'Asia/Colombo': ['Colombo', 'Dehiwala-Mount Lavinia', 'Maharagama', 'Jaffna'],
  'Asia/Kolkata': ['Mumbai', 'Delhi', 'Bengaluru', 'Hyderabad'],
  'Asia/Kathmandu': ['Kathmandu', 'Pokhara', 'Bharatpur', 'Pātan'],
  'Asia/Dhaka': ['Dhaka', 'Chattogram', 'Gazipur', 'Khulna'],
  'Asia/Thimphu': ['Thimphu', 'Phuntsholing', 'Tsirang', 'Punākha'],
  'Asia/Urumqi': ['Ürümqi', 'Shihezi', 'Korla', 'Aqsu'],
  'Indian/Chagos': ['Chagos'],
  'Asia/Bishkek': ['Bishkek', 'Osh', 'Jalal-Abad', 'Karakol'],
  'Asia/Omsk': ['Omsk', 'Tara', 'Kalachinsk', 'Isil’kul’'],
  'Indian/Cocos': ['West Island'],
  'Asia/Yangon': ['Yangon', 'Mandalay', 'Nay Pyi Taw', 'Mawlamyine'],
  'Indian/Christmas': ['Flying Fish Cove'],
  'Antarctica/Davis': ['Davis'],
  'Asia/Hovd': ['Ulaangom', 'Khovd', 'Ölgii', 'Altai'],
  'Asia/Bangkok': ['Bangkok', 'Samut Prakan', 'Mueang Nonthaburi', 'Chon Buri'],
  'Asia/Ho_Chi_Minh': ['Ho Chi Minh City', 'Cần Thơ', 'Da Nang', 'Biên Hòa'],
  'Asia/Phnom_Penh': ['Phnom Penh', 'Takeo', 'Siem Reap', 'Battambang'],
  'Asia/Vientiane': ['Vientiane', 'Savannakhet', 'Pakse', 'Thakhèk'],
  'Asia/Novosibirsk': ['Novosibirsk', 'Krasnoyarsk', 'Barnaul', 'Tomsk'],
  'Asia/Jakarta': ['Jakarta', 'Surabaya', 'Bekasi', 'Bandung'],
  'Antarctica/Casey': ['Casey'],
  'Australia/Perth': ['Perth', 'Mandurah', 'Bunbury', 'Geraldton'],
  'Asia/Brunei': ['Bandar Seri Begawan', 'Sengkurong', 'Mentiri', 'Kuala Belait'],
  'Asia/Makassar': ['Makassar', 'Samarinda', 'Denpasar', 'Balikpapan'],
  'Asia/Macau': ['Macau', 'Taipa', 'Luhuan', 'Zhuojiacun'],
  'Asia/Shanghai': ['Shanghai', 'Beijing', 'Shenzhen', 'Guangzhou'],
  'Asia/Hong_Kong': ['Hong Kong', 'New Territories', 'Kowloon', 'Hong Kong Island'],
  'Asia/Irkutsk': ['Irkutsk', 'Ulan-Ude', 'Bratsk', 'Angarsk'],
  'Asia/Kuala_Lumpur': ['Kuala Lumpur', 'Klang', 'Johor Bahru', 'Kampung Baru Subang'],
  'Asia/Manila': ['Quezon City', 'Davao', 'Caloocan City', 'Manila'],
  'Asia/Singapore': ['Singapore', 'Ulu Bedok', 'Bedok New Town', 'Tampines Estate'],
  'Asia/Taipei': ['Taipei', 'New Taipei City', 'Taichung', 'Kaohsiung'],
  'Asia/Ulaanbaatar': ['Ulan Bator', 'Erdenet', 'Darhan', 'Mörön'],
  'Australia/Eucla': ['Eucla'],
  'Asia/Jayapura': ['Jayapura', 'Ambon', 'Sorong', 'Ternate'],
  'Asia/Tokyo': ['Tokyo', 'Yokohama', 'Osaka', 'Nagoya'],
  'Asia/Pyongyang': ['Pyongyang', 'Hamhŭng', 'Namp’o', 'Sunch’ŏn'],
  'Asia/Seoul': ['Seoul', 'Busan', 'Incheon', 'Daegu'],
  'Pacific/Palau': ['Ngerulmud'],
  'Asia/Dili': ['Dili', 'Maliana', 'Suai', 'Likisá'],
  'Asia/Chita': ['Chita', 'Yakutsk', 'Blagoveshchensk', 'Belogorsk'],
  'Australia/Adelaide': ['Adelaide', 'Adelaide Hills', 'Mount Gambier', 'Morphett Vale'],
  'Australia/Darwin': ['Darwin', 'Alice Springs', 'Palmerston'],
  'Australia/Brisbane': ['Brisbane', 'Gold Coast', 'Sunshine Coast', 'Logan City'],
  'Australia/Sydney': ['Sydney', 'Melbourne', 'Newcastle', 'Canberra'],
  'Pacific/Guam': ['Dededo Village', 'Yigo Village', 'Tamuning-Tumon-Harmon Village', 'Tamuning'],
  'Pacific/Saipan': ['Saipan'],
  'Pacific/Chuuk': ['Chuuk'],
  'Antarctica/DumontDUrville': ['DumontDUrville'],
  'Pacific/Port_Moresby': ['Port Moresby', 'Lae', 'Mount Hagen', 'Popondetta'],
  'Asia/Vladivostok': ['Khabarovsk', 'Vladivostok', 'Khabarovsk Vtoroy', 'Komsomolsk-on-Amur'],
  'Australia/Lord_Howe': ['Lord Howe'],
  'Pacific/Bougainville': ['Arawa'],
  'Pacific/Kosrae': ['Kosrae', 'Palikir'],
  'Pacific/Noumea': ['Nouméa', 'Mont-Dore', 'Dumbéa'],
  'Pacific/Norfolk': ['Kingston'],
  'Asia/Sakhalin': ['Yuzhno-Sakhalinsk', 'Magadan', 'Korsakov', 'Kholmsk'],
  'Pacific/Guadalcanal': ['Honiara'],
  'Pacific/Efate': ['Port-Vila'],
  'Pacific/Fiji': ['Nasinu', 'Suva', 'Lautoka', 'Nadi'],
  'Pacific/Tarawa': ['Tarawa'],
  'Asia/Kamchatka': ['Petropavlovsk-Kamchatsky', 'Yelizovo', 'Vilyuchinsk', 'Anadyr'],
  'Pacific/Majuro': ['Majuro', 'Kwajalein'],
  'Pacific/Nauru': ['Yaren'],
  'Pacific/Auckland': ['Auckland', 'Christchurch', 'Wellington', 'Manukau City'],
  'Antarctica/McMurdo': ['McMurdo'],
  'Pacific/Funafuti': ['Funafuti'],
  'Pacific/Wake': ['Wake'],
  'Pacific/Wallis': ['Mata-Utu'],
  'Pacific/Chatham': ['Chatham'],
  'Pacific/Kanton': ['Kanton'],
  'Pacific/Apia': ['Apia'],
  'Pacific/Fakaofo': ['Fakaofo'],
  'Pacific/Tongatapu': ['Nuku‘alofa'],
  'Pacific/Kiritimati': ['Kiritimati'],
  UTC: [''],
} as const
